// import { ReactComponent as DashboardIcon } from "../asset/icons/sidebar/dashboard.svg";
// import { ReactComponent as ProfileIcon } from "../asset/icons/sidebar/profile.svg";
// import { ReactComponent as SettingsIcon } from "../asset/icons/sidebar/settings.svg";
// import { ReactComponent as MessagesIcon } from "../asset/icons/sidebar/messages.svg";
// import { ReactComponent as ReportsIcon } from "../asset/icons/sidebar/reports.svg";
// import { ReactComponent as ClubIcon } from "../asset/icons/sidebar/club.svg";
// import { ReactComponent as ScoresIcon } from "../asset/icons/sidebar/scores.svg";
// import { ReactComponent as Comment } from "../asset/icons/sidebar/comment.svg";
// import { ReactComponent as Bests } from "../asset/icons/sidebar/bests.svg";
// import { ReactComponent as Discount } from "../asset/icons/sidebar/discount.svg";
// import { ReactComponent as Basket } from "../asset/icons/sidebar/basket.svg";

//global

export const MAX_FILE_SIZE = 100000000;
//main

// export const SIDEBAR_LIST = [
//   {
//     title: "داشبورد",
//     icon: <DashboardIcon />,
//     iconName: <DashboardIcon />,
//     addressLink: "/dashboard",
//   },
//   {
//     title: "پروفایل",
//     icon: <ProfileIcon />,
//     iconName: <ProfileIcon />,
//     addressLink: "/profile",
//   },
//   {
//     title: "پیام ها",
//     icon: <MessagesIcon />,
//     iconName: <MessagesIcon />,
//     addressLink: "/messages/organ",
//   },
//   {
//     title: "گزارش ها",
//     icon: <ReportsIcon />,
//     iconName: <ReportsIcon />,
//     addressLink: "/report",
//   },
//   {
//     title: "باشگاه مشتریان",
//     icon: <ClubIcon />,
//     iconName: <ClubIcon />,
//     addressLink: "/customer-club",
//   },
//   {
//     title: "سبد فروش",
//     icon: <Basket />,
//     iconName: <Basket />,
//     addressLink: "/market/1",
//   },
//   {
//     title: "مدیریت امتیازها",
//     icon: <ScoresIcon />,
//     iconName: <ScoresIcon />,
//     addressLink: "/rating",
//   },
//   {
//     title: "تنظیمات",
//     icon: <SettingsIcon />,
//     iconName: <SettingsIcon />,
//     addressLink: "/settings",
//   },
// ];

// export const USER_SIDEBAR_LIST = [
//   {
//     title: "داشبورد",
//     iconName: <DashboardIcon />,
//     addressLink: "/user/dashboard",
//   },
//   {
//     title: "پروفایل",
//     iconName: <ProfileIcon />,
//     addressLink: "/user/profile",
//   },
//   {
// 	title: "پیام ها",
// 	icon: <MessagesIcon />,
// 	iconName: <MessagesIcon />,
// 	addressLink: "/messages/user",
//   },
//   {
//     title: "باشگاه مشتریان",
//     iconName: <ClubIcon />,
//     addressLink: "/user/customer-club",
//   },
//   {
// 	title: "نظرسنجی و فراخوان ها",
// 	icon: <Comment />,
// 	iconName: <Comment />,
// 	addressLink: "/user/poll",
//   },
//   {
// 	title: 'کارت تخفیف و صرافی',
// 	iconName: <Discount />,
// 	addressLink: '/user/exchange',
// },
// {
// 	title: 'برترین ها',
// 	iconName: <Bests />,
// 	addressLink: '/user/bests',
// },
// ];

//setting page
// export const SETTING_PAGE_TABS = [
//   // { id: '1', title: 'نوع آیتم', type: 'itemType' },
//   { id: "2", title: "فیلد اطلاعاتی", type: "informationField" },
//   { id: "3", title: "فرم ها", type: "forms" },
//   { id: "4", title: "آیتم ها", type: "items" },
// ];
export const SETTING_SIDEBAR_ITEMS = [
    { id: 0, title: "نوع آیتم", type: "itemType" },
    { id: 1, title: "فیلد اطلاعاتی", type: "informationField" },
    { id: 2, title: "فرم ها", type: "forms" },
    { id: 3, title: "آیتم ها", type: "items" },
];
export const ITEMTYPE_PARENTS_LIST2 = {
    name: "",
    id: 0,
    toggled: true,
    className: "zeroLevel",
    children: [
        {
            id: 1,
            name: "child1",
            className: "firstLevel",
            children: [
                { name: "child11", id: 11 },
                { name: "child12", id: 12 },
                { name: "child13", id: 13 },
                { name: "child14", id: 14 },
                { name: "child15", id: 15, children: [] },
            ],
        },
        {
            name: "child3",
            id: 2,
            className: "firstLevel",
            children: [
                {
                    name: "child31",
                    id: 31,
                    toggled: true,
                    children: [
                        { name: "child311", id: 311 },
                        { name: "child312", id: 312 },
                    ],
                },
                { name: "index.js", id: 321 },
            ],
        },
        {
            name: "child4",
            id: 3,
            className: "firstLevel",
            children: [
                { name: "child41", id: 41 },
                { name: "child42", id: 42 },
            ],
        },
        { name: "child5", className: "firstLevel", id: 4 },
        { name: "child6", className: "firstLevel", id: 5 },
        { name: "child7", className: "firstLevel", id: 6 },
    ],
};
//***parents
export const ITEMTYPE_PARENTS_LIST = {
    name: "",
    id: 0,
    toggled: true,
    className: "zeroLevel",
    children: [
        {
            name: "child1",
            className: "firstLevel",
            children: [
                { name: "child11" },
                { name: "child12" },
                { name: "child13" },
                { name: "child14" },
                { name: "child15" },
            ],
        },
        {
            name: "child3",
            className: "firstLevel",
            children: [
                {
                    name: "child31",
                    children: [{ name: "child311" }, { name: "child312" }],
                },
                { name: "index.js" },
            ],
        },
        {
            name: "child4",
            className: "firstLevel",
            children: [{ name: "child41" }, { name: "child42" }],
        },
        { name: "child5", className: "firstLevel" },
        { name: "child6", className: "firstLevel" },
        { name: "child7", className: "firstLevel" },
    ],
};
export const ITEMTS_PARENTS_LIST = {
    name: "",
    id: 0,
    toggled: true,
    className: "zeroLevel",
    children: [
        {
            name: "child1",
            className: "firstLevel",
            children: [
                { name: "child11" },
                { name: "child12" },
                { name: "child13" },
                { name: "child14" },
                { name: "child15" },
            ],
        },
        {
            name: "child2",
            className: "firstLevel",
            loading: true,
            children: [],
        },
        {
            name: "child3",
            className: "firstLevel",
            children: [
                {
                    name: "child31",
                    children: [{ name: "child311" }, { name: "child312" }],
                },
                { name: "index.js" },
            ],
        },
        {
            name: "child4",
            className: "firstLevel",
            children: [{ name: "child41" }, { name: "child42" }],
        },
        { name: "child5", className: "firstLevel" },
        { name: "child6", className: "firstLevel" },
        { name: "child7", className: "firstLevel" },
    ],
};
export const CRITERIA_PARENTS = {
    name: "",
    id: 0,
    toggled: true,
    className: "zeroLevel",
    children: [
        { id: 1, name: "organ5", className: "firstLevel" },
        { id: 1, name: "organ6", className: "firstLevel" },
        { id: 1, name: "organ7", className: "firstLevel" },
    ],
};
//***for form fileds
export const ORGANS = {
    name: "",
    id: 0,
    toggled: true,
    className: "zeroLevel",
    children: [
        { name: "organ5", className: "firstLevel" },
        { name: "organ6", className: "firstLevel" },
        { name: "organ7", className: "firstLevel" },
    ],
};
export const USER_TYPE = {
    name: "",
    id: 0,
    toggled: true,
    className: "zeroLevel",
    children: [
        { id: 1, name: "user5", className: "firstLevel", children: [] },
        { id: 2, name: "user6", className: "firstLevel", children: [] },
        { id: 3, name: "user7", className: "firstLevel", children: [] },
    ],
};
export const FEATURE_TYPE = {
    name: "",
    id: 0,
    toggled: true,
    className: "zeroLevel",
    children: [
        {
            id: 1,
            name: "متنی",
            className: "firstLevel",
            children: [],
        },
        {
            id: 2,
            name: "فایل",
            className: "firstLevel",
            children: [],
        },
        {
            id: 3,
            name: "عکس",
            className: "firstLevel",
            children: [],
        },
        {
            id: 4,
            name: "متنی",
            className: "firstLevel",
            children: [],
        },
    ],
};
export const INFORMATIONS_FILED = {
    name: "",
    id: 0,
    toggled: true,
    className: "zeroLevel",
    children: [
        { name: "info5", className: "firstLevel" },
        { name: "info6", className: "firstLevel" },
        { name: "info7", className: "firstLevel" },
    ],
};
export const ANSWER_TYPE = {
    name: "",
    id: 0,
    toggled: true,
    className: "zeroLevel",
    children: [
        { name: "answer5", className: "firstLevel" },
        { name: "answer6", className: "firstLevel" },
        { name: "answer7", className: "firstLevel" },
    ],
};
//*** imoji list
export const EMOJI_LIST = [
    {
        id: 1,
        value: 1,
        name: "sad",
        emoji: `<svg xmlns="http://www.w3.org/2000/svg" width="44.916" height="48" viewBox="0 0 44.916 48">
	<defs>
		<clipPath id="clip-path">
			<path
				id="Path_13"
				data-name="Path 13"
				d="M115.739,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
				fill="#050505"
			/>
		</clipPath>
		<clipPath id="clip-path-2">
			<path
				id="Path_30"
				data-name="Path 30"
				d="M114.013,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
				fill="none"
			/>
		</clipPath>
	</defs>
	<g id="Group_37" data-name="Group 37" transform="translate(-82.963 -28.011)">
		<g id="Group_3" data-name="Group 3" opacity="0.1">
			<path
				id="Path_3"
				data-name="Path 3"
				d="M108.128,34.675h-4.343a14.833,14.833,0,0,0-14.79,14.79l1.048,11.718c0,8.134,5.609,14.827,13.742,14.827h4.343c8.135,0,13.667-6.243,13.667-14.379l1.122-12.168a14.833,14.833,0,0,0-14.788-14.789Z"
				fill="#050505"
			/>
			<path
				id="Path_4"
				data-name="Path 4"
				d="M89.492,39.618c0-3.145.3-11.608,11.608-11.608s14.078,2.546,21.043,2.546a3.9,3.9,0,0,0,3.669-2.1s.15,4.268-1.423,5.84c0,0,2.022,0,3-2.848,0,0,2.908,10.884-5.385,26.672,0,0-.379-11.934-4.574-15.664-4.044-3.594-8.013-2.92-8.612-3.444s3.366,2.92,5.916,3.07c0,0-12.132,1.726-21.044-.375,0,0-1.878,11.532-3.673,16.924,0,0-5.688-4.718-2.169-14.977a3.645,3.645,0,0,0-2.7.3c-1.273.749.225-1.647,2.921-2.1A9.084,9.084,0,0,1,86.2,34Z"
				fill="#050505"
			/>
			<path
				id="Path_5"
				data-name="Path 5"
				d="M117.275,54.146c0-1.943-.838-3.519-1.872-3.519s-1.873,1.576-1.873,3.519.838,3.52,1.873,3.52S117.275,56.092,117.275,54.146Z"
				fill="#050505"
			/>
			<path
				id="Path_6"
				data-name="Path 6"
				d="M99.3,54.146c0-1.943-.838-3.519-1.873-3.519s-1.872,1.576-1.872,3.519.838,3.52,1.872,3.52S99.3,56.092,99.3,54.146Z"
				fill="#050505"
			/>
			<path
				id="Path_7"
				data-name="Path 7"
				d="M100.384,45.309a6.491,6.491,0,0,0-3.7.259,3.993,3.993,0,0,0-1.029.55,2.934,2.934,0,0,0-1.126,2.244,1.122,1.122,0,0,0,.4.99,1.025,1.025,0,0,0,1.2-.22,12.525,12.525,0,0,0,.823-1.017,2.631,2.631,0,0,1,1.616-.847,7.928,7.928,0,0,0,.929-.1,1.633,1.633,0,0,0,1.208-1.5.377.377,0,0,0-.05-.228A.41.41,0,0,0,100.384,45.309Z"
				fill="#050505"
			/>
			<path
				id="Path_8"
				data-name="Path 8"
				d="M112.659,45.488a6.49,6.49,0,0,1,3.711.03,4.009,4.009,0,0,1,1.062.483,2.934,2.934,0,0,1,1.265,2.173,1.122,1.122,0,0,1-.332,1.005,1.026,1.026,0,0,1-1.208-.144,12.547,12.547,0,0,1-.886-.964,2.631,2.631,0,0,0-1.665-.744,8.185,8.185,0,0,1-.933-.039,1.632,1.632,0,0,1-1.3-1.421.375.375,0,0,1,.035-.23.418.418,0,0,1,.251-.149Z"
				fill="#050505"
			/>
			<g id="Group_2" data-name="Group 2">
				<path
					id="Path_9"
					data-name="Path 9"
					d="M115.739,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
					fill="#050505"
				/>
				<g id="Group_1" data-name="Group 1" clip-path="url(#clip-path)">
					<path
						id="Path_10"
						data-name="Path 10"
						d="M115.739,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
						fill="#050505"
					/>
					<path
						id="Path_11"
						data-name="Path 11"
						d="M117.245,62.8c-.01.041-1.036,4.07-10.474,4.289s-10.694-3.756-10.7-3.8C96.035,63.191,117.269,62.7,117.245,62.8Z"
						fill="#050505"
					/>
					<path
						id="Path_12"
						data-name="Path 12"
						d="M112.536,73.1c-.005-.029-.586-2.906-6.046-3.033s-6.2,2.718-6.2,2.748C100.267,72.894,112.55,73.178,112.536,73.1Z"
						fill="#050505"
					/>
				</g>
			</g>
		</g>
		<g id="Group_7" data-name="Group 7">
			<path
				id="Path_21"
				data-name="Path 21"
				d="M106.4,34.675h-4.343a14.833,14.833,0,0,0-14.79,14.79l1.048,11.718c0,8.134,5.609,14.827,13.742,14.827H106.4c8.135,0,13.667-6.243,13.667-14.379l1.122-12.168A14.833,14.833,0,0,0,106.4,34.675Z"
				fill="#e6b89c"
			/>
			<path
				id="Path_22"
				data-name="Path 22"
				d="M87.767,39.618c0-3.145.3-11.608,11.608-11.608s14.078,2.546,21.043,2.546a3.9,3.9,0,0,0,3.669-2.1s.15,4.268-1.423,5.84c0,0,2.022,0,3-2.848,0,0,2.975,10.952-5.318,26.739,0,0-.446-12-4.642-15.732-4.044-3.594-8.013-2.92-8.612-3.444s3.366,2.92,5.916,3.07c0,0-12.132,1.726-21.044-.375,0,0-1.878,11.532-3.673,16.924,0,0-5.688-4.718-2.169-14.977a3.645,3.645,0,0,0-2.7.3c-1.273.749.225-1.647,2.921-2.1A9.084,9.084,0,0,1,84.471,34Z"
				fill="#4b4b4b"
			/>
			<g id="Group_40" data-name="Group 40">
				<path
					id="Path_23"
					data-name="Path 23"
					d="M115.549,54.146c0-1.943-.838-3.519-1.872-3.519S111.8,52.2,111.8,54.146s.838,3.52,1.873,3.52S115.549,56.092,115.549,54.146Z"
					fill="#4b4b4b"
				/>
				<path
					id="Path_24"
					data-name="Path 24"
					d="M97.577,54.146c0-1.943-.838-3.519-1.873-3.519s-1.872,1.576-1.872,3.519.838,3.52,1.872,3.52S97.577,56.092,97.577,54.146Z"
					fill="#4b4b4b"
				/>
				<path
					id="Path_140"
					data-name="Path 140"
					d="M96.368,52.122A1.285,1.285,0,1,0,95.1,53.614a1.394,1.394,0,0,0,1.269-1.492Z"
					transform="translate(0.604 3.345)"
					fill="#f1f1f1"
				/>
				<path
					id="Path_141"
					data-name="Path 141"
					d="M96.368,52.122A1.285,1.285,0,1,0,95.1,53.614a1.394,1.394,0,0,0,1.269-1.492Z"
					transform="translate(18.577 3.519)"
					fill="#f1f1f1"
				/>
			</g>
			<path
				id="Path_25"
				data-name="Path 25"
				d="M98.658,45.309a6.491,6.491,0,0,0-3.7.259,3.993,3.993,0,0,0-1.03.55A2.934,2.934,0,0,0,92.8,48.362a1.122,1.122,0,0,0,.4.99,1.025,1.025,0,0,0,1.2-.22,12.522,12.522,0,0,0,.823-1.017,2.631,2.631,0,0,1,1.616-.847,7.928,7.928,0,0,0,.929-.1,1.633,1.633,0,0,0,1.208-1.5.377.377,0,0,0-.05-.228.41.41,0,0,0-.264-.133Z"
				fill="#4b4b4b"
			/>
			<path
				id="Path_26"
				data-name="Path 26"
				d="M110.933,45.488a6.49,6.49,0,0,1,3.711.03,4.009,4.009,0,0,1,1.062.483,2.934,2.934,0,0,1,1.265,2.173,1.122,1.122,0,0,1-.332,1.005,1.026,1.026,0,0,1-1.208-.144,12.547,12.547,0,0,1-.886-.964,2.631,2.631,0,0,0-1.665-.744,8.185,8.185,0,0,1-.933-.039,1.632,1.632,0,0,1-1.3-1.421.375.375,0,0,1,.034-.23.418.418,0,0,1,.251-.149Z"
				fill="#4b4b4b"
			/>
			<g id="Group_6" data-name="Group 6">
				<g id="Group_5" data-name="Group 5" clip-path="url(#clip-path-2)">
					<path
						id="Path_27"
						data-name="Path 27"
						d="M114.013,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
						fill="#4b4b4b"
					/>
					<path
						id="Path_28"
						data-name="Path 28"
						d="M115.519,62.8c-.01.041-1.036,4.07-10.474,4.289s-10.694-3.756-10.7-3.8C94.309,63.191,115.543,62.7,115.519,62.8Z"
						fill="#fff"
					/>
					<path
						id="Path_29"
						data-name="Path 29"
						d="M110.81,73.1c-.005-.029-.586-2.906-6.046-3.033s-6.2,2.718-6.2,2.748C98.541,72.894,110.824,73.178,110.81,73.1Z"
						fill="#fb739b"
					/>
				</g>
			</g>
		</g>
	</g>
</svg>`,
    },
    {
        id: 2,
        value: 2,
        name: "happy",
        emoji: `<svg xmlns="http://www.w3.org/2000/svg" width="44.916" height="48" viewBox="0 0 44.916 48">
<defs>
	<clipPath id="clip-path">
		<path
			id="Path_13"
			data-name="Path 13"
			d="M115.739,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
			fill="#050505"
		/>
	</clipPath>
	<clipPath id="clip-path-2">
		<path
			id="Path_30"
			data-name="Path 30"
			d="M114.013,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
			fill="none"
		/>
	</clipPath>
</defs>
<g id="Group_37" data-name="Group 37" transform="translate(-82.963 -28.011)">
	<g id="Group_3" data-name="Group 3" opacity="0.1">
		<path
			id="Path_3"
			data-name="Path 3"
			d="M108.128,34.675h-4.343a14.833,14.833,0,0,0-14.79,14.79l1.048,11.718c0,8.134,5.609,14.827,13.742,14.827h4.343c8.135,0,13.667-6.243,13.667-14.379l1.122-12.168a14.833,14.833,0,0,0-14.788-14.789Z"
			fill="#050505"
		/>
		<path
			id="Path_4"
			data-name="Path 4"
			d="M89.492,39.618c0-3.145.3-11.608,11.608-11.608s14.078,2.546,21.043,2.546a3.9,3.9,0,0,0,3.669-2.1s.15,4.268-1.423,5.84c0,0,2.022,0,3-2.848,0,0,2.908,10.884-5.385,26.672,0,0-.379-11.934-4.574-15.664-4.044-3.594-8.013-2.92-8.612-3.444s3.366,2.92,5.916,3.07c0,0-12.132,1.726-21.044-.375,0,0-1.878,11.532-3.673,16.924,0,0-5.688-4.718-2.169-14.977a3.645,3.645,0,0,0-2.7.3c-1.273.749.225-1.647,2.921-2.1A9.084,9.084,0,0,1,86.2,34Z"
			fill="#050505"
		/>
		<path
			id="Path_5"
			data-name="Path 5"
			d="M117.275,54.146c0-1.943-.838-3.519-1.872-3.519s-1.873,1.576-1.873,3.519.838,3.52,1.873,3.52S117.275,56.092,117.275,54.146Z"
			fill="#050505"
		/>
		<path
			id="Path_6"
			data-name="Path 6"
			d="M99.3,54.146c0-1.943-.838-3.519-1.873-3.519s-1.872,1.576-1.872,3.519.838,3.52,1.872,3.52S99.3,56.092,99.3,54.146Z"
			fill="#050505"
		/>
		<path
			id="Path_7"
			data-name="Path 7"
			d="M100.384,45.309a6.491,6.491,0,0,0-3.7.259,3.993,3.993,0,0,0-1.029.55,2.934,2.934,0,0,0-1.126,2.244,1.122,1.122,0,0,0,.4.99,1.025,1.025,0,0,0,1.2-.22,12.525,12.525,0,0,0,.823-1.017,2.631,2.631,0,0,1,1.616-.847,7.928,7.928,0,0,0,.929-.1,1.633,1.633,0,0,0,1.208-1.5.377.377,0,0,0-.05-.228A.41.41,0,0,0,100.384,45.309Z"
			fill="#050505"
		/>
		<path
			id="Path_8"
			data-name="Path 8"
			d="M112.659,45.488a6.49,6.49,0,0,1,3.711.03,4.009,4.009,0,0,1,1.062.483,2.934,2.934,0,0,1,1.265,2.173,1.122,1.122,0,0,1-.332,1.005,1.026,1.026,0,0,1-1.208-.144,12.547,12.547,0,0,1-.886-.964,2.631,2.631,0,0,0-1.665-.744,8.185,8.185,0,0,1-.933-.039,1.632,1.632,0,0,1-1.3-1.421.375.375,0,0,1,.035-.23.418.418,0,0,1,.251-.149Z"
			fill="#050505"
		/>
		<g id="Group_2" data-name="Group 2">
			<path
				id="Path_9"
				data-name="Path 9"
				d="M115.739,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
				fill="#050505"
			/>
			<g id="Group_1" data-name="Group 1" clip-path="url(#clip-path)">
				<path
					id="Path_10"
					data-name="Path 10"
					d="M115.739,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
					fill="#050505"
				/>
				<path
					id="Path_11"
					data-name="Path 11"
					d="M117.245,62.8c-.01.041-1.036,4.07-10.474,4.289s-10.694-3.756-10.7-3.8C96.035,63.191,117.269,62.7,117.245,62.8Z"
					fill="#050505"
				/>
				<path
					id="Path_12"
					data-name="Path 12"
					d="M112.536,73.1c-.005-.029-.586-2.906-6.046-3.033s-6.2,2.718-6.2,2.748C100.267,72.894,112.55,73.178,112.536,73.1Z"
					fill="#050505"
				/>
			</g>
		</g>
	</g>
	<g id="Group_7" data-name="Group 7">
		<path
			id="Path_21"
			data-name="Path 21"
			d="M106.4,34.675h-4.343a14.833,14.833,0,0,0-14.79,14.79l1.048,11.718c0,8.134,5.609,14.827,13.742,14.827H106.4c8.135,0,13.667-6.243,13.667-14.379l1.122-12.168A14.833,14.833,0,0,0,106.4,34.675Z"
			fill="#e6b89c"
		/>
		<path
			id="Path_22"
			data-name="Path 22"
			d="M87.767,39.618c0-3.145.3-11.608,11.608-11.608s14.078,2.546,21.043,2.546a3.9,3.9,0,0,0,3.669-2.1s.15,4.268-1.423,5.84c0,0,2.022,0,3-2.848,0,0,2.975,10.952-5.318,26.739,0,0-.446-12-4.642-15.732-4.044-3.594-8.013-2.92-8.612-3.444s3.366,2.92,5.916,3.07c0,0-12.132,1.726-21.044-.375,0,0-1.878,11.532-3.673,16.924,0,0-5.688-4.718-2.169-14.977a3.645,3.645,0,0,0-2.7.3c-1.273.749.225-1.647,2.921-2.1A9.084,9.084,0,0,1,84.471,34Z"
			fill="#4b4b4b"
		/>
		<g id="Group_40" data-name="Group 40">
			<path
				id="Path_23"
				data-name="Path 23"
				d="M115.549,54.146c0-1.943-.838-3.519-1.872-3.519S111.8,52.2,111.8,54.146s.838,3.52,1.873,3.52S115.549,56.092,115.549,54.146Z"
				fill="#4b4b4b"
			/>
			<path
				id="Path_24"
				data-name="Path 24"
				d="M97.577,54.146c0-1.943-.838-3.519-1.873-3.519s-1.872,1.576-1.872,3.519.838,3.52,1.872,3.52S97.577,56.092,97.577,54.146Z"
				fill="#4b4b4b"
			/>
			<path
				id="Path_140"
				data-name="Path 140"
				d="M96.368,52.122A1.285,1.285,0,1,0,95.1,53.614a1.394,1.394,0,0,0,1.269-1.492Z"
				transform="translate(0.604 3.345)"
				fill="#f1f1f1"
			/>
			<path
				id="Path_141"
				data-name="Path 141"
				d="M96.368,52.122A1.285,1.285,0,1,0,95.1,53.614a1.394,1.394,0,0,0,1.269-1.492Z"
				transform="translate(18.577 3.519)"
				fill="#f1f1f1"
			/>
		</g>
		<path
			id="Path_25"
			data-name="Path 25"
			d="M98.658,45.309a6.491,6.491,0,0,0-3.7.259,3.993,3.993,0,0,0-1.03.55A2.934,2.934,0,0,0,92.8,48.362a1.122,1.122,0,0,0,.4.99,1.025,1.025,0,0,0,1.2-.22,12.522,12.522,0,0,0,.823-1.017,2.631,2.631,0,0,1,1.616-.847,7.928,7.928,0,0,0,.929-.1,1.633,1.633,0,0,0,1.208-1.5.377.377,0,0,0-.05-.228.41.41,0,0,0-.264-.133Z"
			fill="#4b4b4b"
		/>
		<path
			id="Path_26"
			data-name="Path 26"
			d="M110.933,45.488a6.49,6.49,0,0,1,3.711.03,4.009,4.009,0,0,1,1.062.483,2.934,2.934,0,0,1,1.265,2.173,1.122,1.122,0,0,1-.332,1.005,1.026,1.026,0,0,1-1.208-.144,12.547,12.547,0,0,1-.886-.964,2.631,2.631,0,0,0-1.665-.744,8.185,8.185,0,0,1-.933-.039,1.632,1.632,0,0,1-1.3-1.421.375.375,0,0,1,.034-.23.418.418,0,0,1,.251-.149Z"
			fill="#4b4b4b"
		/>
		<g id="Group_6" data-name="Group 6">
			<g id="Group_5" data-name="Group 5" clip-path="url(#clip-path-2)">
				<path
					id="Path_27"
					data-name="Path 27"
					d="M114.013,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
					fill="#4b4b4b"
				/>
				<path
					id="Path_28"
					data-name="Path 28"
					d="M115.519,62.8c-.01.041-1.036,4.07-10.474,4.289s-10.694-3.756-10.7-3.8C94.309,63.191,115.543,62.7,115.519,62.8Z"
					fill="#fff"
				/>
				<path
					id="Path_29"
					data-name="Path 29"
					d="M110.81,73.1c-.005-.029-.586-2.906-6.046-3.033s-6.2,2.718-6.2,2.748C98.541,72.894,110.824,73.178,110.81,73.1Z"
					fill="#fb739b"
				/>
			</g>
		</g>
	</g>
</g>
</svg>`,
    },
    {
        id: 3,
        value: 3,
        name: "angry",
        emoji: `<svg xmlns="http://www.w3.org/2000/svg" width="44.916" height="48" viewBox="0 0 44.916 48">
	<defs>
		<clipPath id="clip-path">
			<path
				id="Path_13"
				data-name="Path 13"
				d="M115.739,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
				fill="#050505"
			/>
		</clipPath>
		<clipPath id="clip-path-2">
			<path
				id="Path_30"
				data-name="Path 30"
				d="M114.013,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
				fill="none"
			/>
		</clipPath>
	</defs>
	<g id="Group_37" data-name="Group 37" transform="translate(-82.963 -28.011)">
		<g id="Group_3" data-name="Group 3" opacity="0.1">
			<path
				id="Path_3"
				data-name="Path 3"
				d="M108.128,34.675h-4.343a14.833,14.833,0,0,0-14.79,14.79l1.048,11.718c0,8.134,5.609,14.827,13.742,14.827h4.343c8.135,0,13.667-6.243,13.667-14.379l1.122-12.168a14.833,14.833,0,0,0-14.788-14.789Z"
				fill="#050505"
			/>
			<path
				id="Path_4"
				data-name="Path 4"
				d="M89.492,39.618c0-3.145.3-11.608,11.608-11.608s14.078,2.546,21.043,2.546a3.9,3.9,0,0,0,3.669-2.1s.15,4.268-1.423,5.84c0,0,2.022,0,3-2.848,0,0,2.908,10.884-5.385,26.672,0,0-.379-11.934-4.574-15.664-4.044-3.594-8.013-2.92-8.612-3.444s3.366,2.92,5.916,3.07c0,0-12.132,1.726-21.044-.375,0,0-1.878,11.532-3.673,16.924,0,0-5.688-4.718-2.169-14.977a3.645,3.645,0,0,0-2.7.3c-1.273.749.225-1.647,2.921-2.1A9.084,9.084,0,0,1,86.2,34Z"
				fill="#050505"
			/>
			<path
				id="Path_5"
				data-name="Path 5"
				d="M117.275,54.146c0-1.943-.838-3.519-1.872-3.519s-1.873,1.576-1.873,3.519.838,3.52,1.873,3.52S117.275,56.092,117.275,54.146Z"
				fill="#050505"
			/>
			<path
				id="Path_6"
				data-name="Path 6"
				d="M99.3,54.146c0-1.943-.838-3.519-1.873-3.519s-1.872,1.576-1.872,3.519.838,3.52,1.872,3.52S99.3,56.092,99.3,54.146Z"
				fill="#050505"
			/>
			<path
				id="Path_7"
				data-name="Path 7"
				d="M100.384,45.309a6.491,6.491,0,0,0-3.7.259,3.993,3.993,0,0,0-1.029.55,2.934,2.934,0,0,0-1.126,2.244,1.122,1.122,0,0,0,.4.99,1.025,1.025,0,0,0,1.2-.22,12.525,12.525,0,0,0,.823-1.017,2.631,2.631,0,0,1,1.616-.847,7.928,7.928,0,0,0,.929-.1,1.633,1.633,0,0,0,1.208-1.5.377.377,0,0,0-.05-.228A.41.41,0,0,0,100.384,45.309Z"
				fill="#050505"
			/>
			<path
				id="Path_8"
				data-name="Path 8"
				d="M112.659,45.488a6.49,6.49,0,0,1,3.711.03,4.009,4.009,0,0,1,1.062.483,2.934,2.934,0,0,1,1.265,2.173,1.122,1.122,0,0,1-.332,1.005,1.026,1.026,0,0,1-1.208-.144,12.547,12.547,0,0,1-.886-.964,2.631,2.631,0,0,0-1.665-.744,8.185,8.185,0,0,1-.933-.039,1.632,1.632,0,0,1-1.3-1.421.375.375,0,0,1,.035-.23.418.418,0,0,1,.251-.149Z"
				fill="#050505"
			/>
			<g id="Group_2" data-name="Group 2">
				<path
					id="Path_9"
					data-name="Path 9"
					d="M115.739,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
					fill="#050505"
				/>
				<g id="Group_1" data-name="Group 1" clip-path="url(#clip-path)">
					<path
						id="Path_10"
						data-name="Path 10"
						d="M115.739,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
						fill="#050505"
					/>
					<path
						id="Path_11"
						data-name="Path 11"
						d="M117.245,62.8c-.01.041-1.036,4.07-10.474,4.289s-10.694-3.756-10.7-3.8C96.035,63.191,117.269,62.7,117.245,62.8Z"
						fill="#050505"
					/>
					<path
						id="Path_12"
						data-name="Path 12"
						d="M112.536,73.1c-.005-.029-.586-2.906-6.046-3.033s-6.2,2.718-6.2,2.748C100.267,72.894,112.55,73.178,112.536,73.1Z"
						fill="#050505"
					/>
				</g>
			</g>
		</g>
		<g id="Group_7" data-name="Group 7">
			<path
				id="Path_21"
				data-name="Path 21"
				d="M106.4,34.675h-4.343a14.833,14.833,0,0,0-14.79,14.79l1.048,11.718c0,8.134,5.609,14.827,13.742,14.827H106.4c8.135,0,13.667-6.243,13.667-14.379l1.122-12.168A14.833,14.833,0,0,0,106.4,34.675Z"
				fill="#e6b89c"
			/>
			<path
				id="Path_22"
				data-name="Path 22"
				d="M87.767,39.618c0-3.145.3-11.608,11.608-11.608s14.078,2.546,21.043,2.546a3.9,3.9,0,0,0,3.669-2.1s.15,4.268-1.423,5.84c0,0,2.022,0,3-2.848,0,0,2.975,10.952-5.318,26.739,0,0-.446-12-4.642-15.732-4.044-3.594-8.013-2.92-8.612-3.444s3.366,2.92,5.916,3.07c0,0-12.132,1.726-21.044-.375,0,0-1.878,11.532-3.673,16.924,0,0-5.688-4.718-2.169-14.977a3.645,3.645,0,0,0-2.7.3c-1.273.749.225-1.647,2.921-2.1A9.084,9.084,0,0,1,84.471,34Z"
				fill="#4b4b4b"
			/>
			<g id="Group_40" data-name="Group 40">
				<path
					id="Path_23"
					data-name="Path 23"
					d="M115.549,54.146c0-1.943-.838-3.519-1.872-3.519S111.8,52.2,111.8,54.146s.838,3.52,1.873,3.52S115.549,56.092,115.549,54.146Z"
					fill="#4b4b4b"
				/>
				<path
					id="Path_24"
					data-name="Path 24"
					d="M97.577,54.146c0-1.943-.838-3.519-1.873-3.519s-1.872,1.576-1.872,3.519.838,3.52,1.872,3.52S97.577,56.092,97.577,54.146Z"
					fill="#4b4b4b"
				/>
				<path
					id="Path_140"
					data-name="Path 140"
					d="M96.368,52.122A1.285,1.285,0,1,0,95.1,53.614a1.394,1.394,0,0,0,1.269-1.492Z"
					transform="translate(0.604 3.345)"
					fill="#f1f1f1"
				/>
				<path
					id="Path_141"
					data-name="Path 141"
					d="M96.368,52.122A1.285,1.285,0,1,0,95.1,53.614a1.394,1.394,0,0,0,1.269-1.492Z"
					transform="translate(18.577 3.519)"
					fill="#f1f1f1"
				/>
			</g>
			<path
				id="Path_25"
				data-name="Path 25"
				d="M98.658,45.309a6.491,6.491,0,0,0-3.7.259,3.993,3.993,0,0,0-1.03.55A2.934,2.934,0,0,0,92.8,48.362a1.122,1.122,0,0,0,.4.99,1.025,1.025,0,0,0,1.2-.22,12.522,12.522,0,0,0,.823-1.017,2.631,2.631,0,0,1,1.616-.847,7.928,7.928,0,0,0,.929-.1,1.633,1.633,0,0,0,1.208-1.5.377.377,0,0,0-.05-.228.41.41,0,0,0-.264-.133Z"
				fill="#4b4b4b"
			/>
			<path
				id="Path_26"
				data-name="Path 26"
				d="M110.933,45.488a6.49,6.49,0,0,1,3.711.03,4.009,4.009,0,0,1,1.062.483,2.934,2.934,0,0,1,1.265,2.173,1.122,1.122,0,0,1-.332,1.005,1.026,1.026,0,0,1-1.208-.144,12.547,12.547,0,0,1-.886-.964,2.631,2.631,0,0,0-1.665-.744,8.185,8.185,0,0,1-.933-.039,1.632,1.632,0,0,1-1.3-1.421.375.375,0,0,1,.034-.23.418.418,0,0,1,.251-.149Z"
				fill="#4b4b4b"
			/>
			<g id="Group_6" data-name="Group 6">
				<g id="Group_5" data-name="Group 5" clip-path="url(#clip-path-2)">
					<path
						id="Path_27"
						data-name="Path 27"
						d="M114.013,62.943c-.007.093-.777,9.312-9.114,9.505s-9.572-8.975-9.579-9.069Z"
						fill="#4b4b4b"
					/>
					<path
						id="Path_28"
						data-name="Path 28"
						d="M115.519,62.8c-.01.041-1.036,4.07-10.474,4.289s-10.694-3.756-10.7-3.8C94.309,63.191,115.543,62.7,115.519,62.8Z"
						fill="#fff"
					/>
					<path
						id="Path_29"
						data-name="Path 29"
						d="M110.81,73.1c-.005-.029-.586-2.906-6.046-3.033s-6.2,2.718-6.2,2.748C98.541,72.894,110.824,73.178,110.81,73.1Z"
						fill="#fb739b"
					/>
				</g>
			</g>
		</g>
	</g>
	</svg>`,
    },
];

//message
// export const MESSAGE_PAGE_TABS = [
//     { id: "1", title: "جزییات نظر", type: "commentDetails" },
//     { id: "2", title: "تصاویر ارسالی", type: "sendingImages" },
//     { id: "3", title: "گردش گزارش", type: "report" },
//     { id: "4", title: "اشتراک گذاری", type: "sharing" },
// ];

export const clubLevels = [
    {
        id: 1,
        title: "کاربران عادی",
    },
    {
        id: 2,
        title: "کاربران فعال",
    },
    {
        id: 3,
        title: "کاربران حامی",
    },
];
export const feedbackStatus = [null, "new", "open", "in-progress", "closed"];
